import CARCS_JSON from './json/CARCS.json'
import OTHER_JSON from './json/Other.json'
import RARCS_JSON from './json/RARCS.json'

export const NATERA_TAG_TYPE = 'Natera Tags'

export const NATERA_TAGS: Array<{
  code: string
  description: string
  label: string
  phase: string[]
  outcome: string[]
  reason: string[]
  occurrences: number
  futureStateType: string
}> = [...OTHER_JSON, ...CARCS_JSON, ...RARCS_JSON].filter(
  (other) => other.futureStateType === NATERA_TAG_TYPE,
)
